import { PillarIconColors } from '@primer/react-brand';
import { IconColors } from '@primer/react-brand';
import { CopilotIcon, RocketIcon, GitBranchIcon } from '@primer/octicons-react';
import { PropTableValues } from "../../../../src/components";
import ComponentLayout from "../../../../src/layouts/component-layout";
import * as React from 'react';
export default {
  PillarIconColors,
  IconColors,
  CopilotIcon,
  RocketIcon,
  GitBranchIcon,
  PropTableValues,
  ComponentLayout,
  React
};